import { CommerceToolsApi } from '@grandvisionhq/commercetools';
import * as React from 'react';
import React__default, { useContext } from 'react';
import classnames from 'classnames';
import { Tooltip } from '@grandvisionhq/common';
import { useIntl } from '@grandvisionhq/state';

function getAvailableQuantity(availability) {
    const channels = availability && availability.channels || {};
    const quantity = Object.entries(channels).map(([channelId, channel])=>channel && channel.availableQuantity || 0
    ).reduce((acc, val)=>acc + val
    , 0);
    return quantity;
}

var helpers$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  getAvailableQuantity: getAvailableQuantity
});

function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}

function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === 'function') {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}

const defaultStockLevels = [
    // Order matters! The `findStock()` method will walk through this array and stop at its first match
    {
        threshold: 10,
        labelId: 'inStock'
    },
    {
        threshold: 5,
        labelId: 'lowStock'
    },
    {
        threshold: 1,
        labelId: 'veryLowStock'
    },
    {
        threshold: 0,
        labelId: 'outOfStock'
    }, 
];
const getStockLevels = (thresholdConfig = [])=>defaultStockLevels.map((level)=>_objectSpread({}, level, thresholdConfig.find((threshold)=>threshold.labelId === level.labelId
        ))
    )
;
const defaultStockResolver = (allowBackOrder, stockCount, thresholdConfig, productTypeName)=>{
    // opcos can display a stock message on frames PDP by using a custom stock resolver
    if (typeof stockCount !== 'number' || productTypeName && CommerceToolsApi.isFrames(productTypeName)) {
        return;
    }
    const positiveStockCount = Math.max(stockCount, 0) // No negative stockCount
    ;
    if (!positiveStockCount && allowBackOrder) {
        return {
            threshold: 0,
            labelId: 'backOrder'
        };
    }
    return getStockLevels(thresholdConfig).find((stockLevel)=>positiveStockCount >= stockLevel.threshold
    );
};

var helpers = /*#__PURE__*/Object.freeze({
  __proto__: null,
  defaultStockLevels: defaultStockLevels,
  getStockLevels: getStockLevels,
  defaultStockResolver: defaultStockResolver
});

const settingsDefaults = {
    thresholds: []
};
const StockIndicatorContext = /*#__PURE__*/ React__default.createContext({});
const useStockIndicator = ()=>useContext(StockIndicatorContext)
;

const inventoryClassNames = {
    inStock: 'in-stock',
    lowStock: 'low-stock',
    veryLowStock: 'very-low-stock',
    outOfStock: 'out-of-stock',
    backOrder: 'back-order',
    availableInStore: 'available-in-store'
};
const StockIndicator = ({ stockCount , allowBackOrder =true , stockResolver , productTypeName ,  })=>{
    const { getLabel  } = useIntl();
    const { thresholds  } = useStockIndicator();
    const stock = stockResolver ? stockResolver(allowBackOrder, stockCount, thresholds, productTypeName) : defaultStockResolver(allowBackOrder, stockCount, thresholds, productTypeName);
    if (!stock) {
        return null;
    }
    const { labelId , tooltipId  } = stock;
    const shouldShowTooltip = tooltipId || labelId === 'backOrder';
    const inventoryClass = labelId.substr(labelId.lastIndexOf('.') + 1);
    return /*#__PURE__*/ React.createElement("div", {
        className: classnames('stock-indicator', {
            [`stock-indicator--level-${inventoryClassNames[inventoryClass]}`]: inventoryClassNames[inventoryClass]
        })
    }, /*#__PURE__*/ React.createElement("div", {
        className: "stock-indicator__levels"
    }, /*#__PURE__*/ React.createElement("span", {
        className: "stock-indicator__levels-level"
    })), /*#__PURE__*/ React.createElement("span", {
        className: "stock-indicator__label"
    }, getLabel(`products.stockInfo.${labelId}`)), shouldShowTooltip && /*#__PURE__*/ React.createElement(Tooltip, {
        id: "stock-indicator",
        className: "stock-indicator__tooltip",
        // All stock levels can have a tooltip when configured through a custom config
        // inStockTooltip, lowStockTooltip, veryLowStockTooltip, outOfStockTooltip, backOrderTooltip
        message: getLabel(`products.stockInfo.${tooltipId || 'backOrder'}Tooltip`),
        placement: "right"
    }));
};

const createContext = (settings = {})=>{
    return _objectSpread({}, settingsDefaults, settings);
};
const StockIndicatorProvider = ({ children , settings  })=>/*#__PURE__*/ React.createElement(StockIndicatorContext.Provider, {
        value: createContext(settings)
    }, children)
;

export { helpers$1 as Helpers, StockIndicator, StockIndicatorContext, helpers as StockIndicatorHelpers, StockIndicatorProvider };
//# sourceMappingURL=index.js.map
